export default __webpack_public_path__ + "static/media/flagIcon.31092b84.svg";